import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import browser, { dom } from '../../../../browser';

const DISABLED_CLASS = 'oc-imageLink--disabled';

let allLinks = [];
let shouldZoomIntoImage = false;

function checkImageSize(image, parent) {
  if (!image.complete) {
    image.addEventListener('load', () => checkImageSize(image, parent));
    return;
  }

  if (image.width < image.naturalWidth || image.height < image.naturalHeight) {
    parent.classList.remove(DISABLED_CLASS);
  } else {
    parent.classList.add(DISABLED_CLASS);
  }
}

export function checkImagesSizes(links = allLinks) {
  links.forEach((link) => {
    const image = link.firstChild;
    checkImageSize(image, link);
  });
}

const onResizeHandler = /* istanbul ignore next */ () => checkImagesSizes();

export function wrap(image) {
  const link = browser.document.createElement('a');
  link.href = image.src;
  link.classList.add('oc-imageLink');

  image.parentNode.insertBefore(link, image);
  link.appendChild(image);

  if (shouldZoomIntoImage) {
    link.setAttribute('data-fancybox', '');
    link.setAttribute('data-caption', image.alt);
  }

  return link;
}

function init(domContainer) {
  shouldZoomIntoImage = 'shouldzoomintoimage' in domContainer.dataset;

  /* istanbul ignore next */
  if (shouldZoomIntoImage) {
    const style = document.createElement('style');
    style.textContent = '.fancybox__container { z-index: 1200 !important; }';
    document.head.appendChild(style);

    Fancybox.bind('[data-fancybox]', {
      Image: {
        zoom: false,
      },
    });
  }

  allLinks = dom.nodeListToArray(domContainer.querySelectorAll('figure img')).map(wrap);

  browser.window.addEventListener('resize', onResizeHandler);
  browser.window.addEventListener('orientationchange', onResizeHandler);

  checkImagesSizes();

  return allLinks;
}

function clear() {
  browser.window.removeEventListener('resize', onResizeHandler);
  browser.window.removeEventListener('orientationchange', onResizeHandler);
  allLinks = [];
}

export default {
  init,
  clear,
};
